import { D } from "@mobily/ts-belt";
import PropTypes from "prop-types";
import { Typography } from "../../../themeV2";
import s from "./SortSelect.module.css";

const sortOptions = [
  { id: "ra", name: "Most Popular" },
  { id: "ca", name: "Oldest" },
  { id: "cd", name: "Newest" },
  { id: "pa", name: "Price: Low to High" },
  { id: "pd", name: "Price: High to Low" },
];

export default function SortSelect({ filter, setFilter }) {
  return (
    <div className={s.wrapper}>
      <Typography
        variant="label-lg"
        color="variant"
        weight="bold"
        as="label"
        htmlFor="browse-sort"
        className={s.label}
      >
        Sort
      </Typography>
      <select
        id="browse-sort"
        className={s.select}
        value={filter.order}
        onChange={(e) => {
          setFilter(D.merge({ cursor: "", order: e.target.value }));
        }}
      >
        {sortOptions.map((option) => (
          <option key={option.id} value={option.id}>
            {option.name}
          </option>
        ))}
      </select>
    </div>
  );
}

SortSelect.propTypes = {
  filter: PropTypes.shape({
    order: PropTypes.string.isRequired,
  }).isRequired,
  setFilter: PropTypes.func.isRequired,
};
